import React, { useEffect } from 'react';
import { Spinner } from '@blueprintjs/core';
import { useObserver } from 'mobx-react-lite';
import { graphAuthStore } from '../lib/graphAuth';
import styles from './GraphAuthPendingNotice.module.sass';

interface Props {
  instanceId?: string;
}

export const GraphAuthPendingNotice = ({ instanceId }: Props) => {
  useEffect(() => {
    return () => {
      if (instanceId) {
        graphAuthStore.clear(instanceId);
      }
    };
  }, [instanceId]);

  return useObserver(() => {
    if (!instanceId) {
      return null;
    }
    const status = graphAuthStore.getStatus(instanceId);
    if (status === 'idle') {
      return null;
    }
    if (status === 'pending') {
      return (
        <div className={`${styles.notice} ${styles.pending}`}>
          <Spinner size={16} />
          <span>
            First use of Graph instance in Connect Platform — setting up authentication. Can take a few minutes; will
            load automatically when ready.
          </span>
        </div>
      );
    }
    return (
      <div className={`${styles.notice} ${styles.error}`}>
        Graph authentication is taking longer than expected. Refresh the page to retry.
      </div>
    );
  });
};
